import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

const PRODUCTS = [
  {
    name: "Granite",
    link: "/products/granite",
    desc: "Wholesale landscape granite: paving, kerb, tread, cobble, wall stone, coping, columns, benches, and more — by code.",
  },
  {
    name: "Limestone & Marble",
    link: "/products/limestone-marble",
    desc: "Limestone in Blue, Brown, Cinderella, Black, Buff, and Grey, and Green Marble Slab (= Ming Green).",
  },
  {
    name: "Sandstone",
    link: "/products/sandstone",
    desc: "Sandstone paving, tread, cobble, wall cladding, coping, window sill, and ledge panel in 15 colours.",
  },
  {
    name: "Pebble & Mosaic",
    link: "/products/pebble-mosaic",
    desc: "Polished pebble, pebble mosaic, and gravel & tumbled pebble, by colour, size, and photo.",
  },
  {
    name: "Volcanic Rock",
    link: "/products/volcanic-rock",
    desc: "Volcanic rock paving, cobble, wall cladding, and ledge panel in Black and Red.",
  },
  {
    name: "Wall Stone & Ledge Panel",
    link: "/products/wall-stone",
    desc: "Wall stone and ledge panel organised by colour — customers choose the colour and the shape is made to order.",
  },
  {
    name: "Brick Mosaic",
    link: "/products/brick-mosaic",
    desc: "Brick mosaic by code and photo only: MSBM-1 to MSBM-34.",
  },
  {
    name: "Carved Animals",
    link: "/products/carved-animals",
    desc: "Carved stone animals by code and photo only: CA1 to CA43.",
  },
  {
    name: "Carved Fountains",
    link: "/products/carved-fountains",
    desc: "Carved stone fountains by code and photo only: CF1 to CF170.",
  },
  {
    name: "Carved Lanterns",
    link: "/products/carved-lanterns",
    desc: "Carved stone lanterns by code and photo only: CL1 to CL113, plus light versions.",
  },
  {
    name: "New Carvings",
    link: "/products/new-carvings",
    desc: "New carvings kept separate from CA, CF, and CL codes: Lantern, Fountain, Elephant, CD, CPX, CK, Lion, and CHP.",
  },
  {
    name: "Flexible Stone Veneer (Soft Stone)",
    link: "/products/flexible-stone-veneer",
    desc: "A separate range: flexible stone veneer with a stone look, for indoor and outdoor wall use, by photo and code.",
  },
];

function ProductsIndexPage() {
  return (
    <Box className="my-10 mx-auto px-4 max-w-5xl">
      <Typography variant="h4" component="h1" className="mb-4">
        Products — Wholesale Natural Stone
      </Typography>
      <Typography variant="body1" className="mb-6">
        Wholesale natural stone for landscaping wholesalers and distributors
        in Europe, North America, and other markets. Supplied from China and
        other origins, direct to your designated location. Prices are on
        request, because they vary by colour, stone type, processing, size,
        quantity, and destination. We process and deliver to meet our
        clients&apos; requirements.
      </Typography>
      <Typography variant="body1" className="mb-8">
        See also our shared{" "}
        <Link to="/products/processing" className="underline">
          Processing
        </Link>{" "}
        page, and our downloadable catalogues on the{" "}
        <Link to="/catalogue" className="underline">
          Catalogue
        </Link>{" "}
        page.
      </Typography>
      <Box className="space-y-6">
        {PRODUCTS.map((p) => (
          <Box key={p.link}>
            <Typography variant="h6" component="h2">
              <Link to={p.link} className="underline">
                {p.name}
              </Link>
            </Typography>
            <Typography variant="body1">{p.desc}</Typography>
          </Box>
        ))}
      </Box>
      <Button
        component={Link}
        to="/contact"
        variant="contained"
        color="brand"
        className="mt-8"
      >
        Request Quote
      </Button>
    </Box>
  );
}

export default ProductsIndexPage;
